import React from 'react';
import { Yes, No, UpArrow, Information } from '../icons/Icons';
import InputRange from 'react-input-range';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: '90%',
    padding: '40px 20px',
    maxWidth: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
  }
};

const closeButton = {
  width: '30px',
}

Modal.setAppElement('#root');


const PageFour = (props) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div className="kids-quiz__page">

      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Antidepressant question explanation"
        >
          <div className="close-modal" onClick={closeModal}><No /></div>
          <div className="modal-copy">
            <p>Certain nourishments are not suitable to take alongside prescription medication so we will exclude them from your recommendation.</p>
            <p>For more information please view our guidelines <a className="modal-link" href="/pages/help-centre-medical-dietary-guidelines" target="_blank">here</a>.</p>
          </div>
        </Modal>
      </div>

      <div id="eyesight" className="kids-quiz__question">
        <p className="question__title">Do you wear glasses or use contact lenses?</p>

        <div className="radio-answers answers-row--2">
          <input type="radio" name="glasses" id="glassesYes" value="yes" onChange={props.logGlassesAnswer} checked={props.glassesAnswer === 'yes'} />
          <label className="answer-button answer-button__glasses" htmlFor="glassesYes"><Yes />Yes</label>

          <input type="radio" name="glasses" id="glassesNo" value="no" onChange={props.logGlassesAnswer} checked={props.glassesAnswer === 'no'} />
          <label className="answer-button answer-button__glasses" htmlFor="glassesNo"><No />No</label>
        </div>
      </div>

      <a href="#healthConditions" className={`question-divider ${props.glassesAnswer ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="healthConditions" className={`kids-quiz__question ${props.glassesAnswer ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">Do you suffer with any of the below?</p>
        <div className="answers-row--flex health-answers">
          {props.renderConditionsAnswers}
        </div>
      </div>

      {props.conditionsAnswerIndex.length > 0 && !props.conditionsAnswerIndex.includes('No') ?
        <>
          <a href="#hypothyroidism" className={`question-divider ${props.conditionsAnswerIndex.includes('Hypothyroidism') ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>

          <div id="hypothyroidism" className={`kids-quiz__question ${props.conditionsAnswerIndex.includes('Hypothyroidism') ? 'kids-quiz__question--show' : 'kids-quiz__question--none'}`}>
            <p className="question__title">Have you had your thyroid removed or should you be avoiding extra iodine in your diet?</p>
            <div className="radio-answers answers-row--2">
              <input type="radio" name="iodine" id="iodineYes" value="yes" onChange={props.logIodineAnswer} checked={props.iodineAnswer === 'yes'} />
              <label className="answer-button answer-button__glasses" htmlFor="iodineYes"><Yes />Yes</label>

              <input type="radio" name="iodine" id="iodineNo" value="no" onChange={props.logIodineAnswer} checked={props.iodineAnswer === 'no'} />
              <label className="answer-button answer-button__glasses" htmlFor="iodineNo"><No />No</label>
            </div>
          </div>

          <a href="#healthConditionsSlider" className={`question-divider ${props.conditionsAnswerIndex.length > 0 ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>

          <div id="healthConditionsSlider" className="kids-quiz__question">
            <p className="question__title">How do these conditions effect your quality of life?</p>
            <div className="range__selector">
              <InputRange
                maxValue={100}
                minValue={1}
                value={props.conditionsEffectSlider}
                onChange={value => props.handleSlider(value, 'conditionsSlider')}
              />
              <div className="range__text">
                <p>No effect</p>
                <p>Daily struggle</p>
              </div>
            </div>
          </div>

          <a href="#healthConditionsManage" className={`question-divider ${props.conditionsAnswerIndex.length > 0 ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>

          <div id="healthConditionsManage" className="kids-quiz__question">
            <p className="question__title">How do you manage your conditions?</p>
            <div className="answers-row--flex health-answers">
              {props.renderManageConditionsAnswers}
            </div>
          </div>

          <a href="#antiDepressants" className={`question-divider ${props.manageConditionsAnswerIndex.length > 0 ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>
        </>
        :
        <a href="#antiDepressants" className={`question-divider ${props.conditionsAnswerIndex.length > 0 ? 'question-divider--show' : ''}`}>
          <UpArrow />
        </a>
      }

      <div id="antiDepressants" className={`kids-quiz__question ${(props.conditionsAnswerIndex.length > 0 && props.conditionsAnswerIndex.includes('No')) || props.manageConditionsAnswerIndex.length > 0 ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">Are you currently taking prescription antidepressants for any medical condition? <span className="open-modal-button" onClick={openModal}><Information /></span></p>
        <div className="radio-answers answers-row--2">
          <input type="radio" name="antiDepressants" id="antiDepressantsYes" value="yes" onChange={props.logMedicationAnswer} checked={props.medicationAnswer === 'yes'} />
          <label className="answer-button answer-button__glasses" htmlFor="antiDepressantsYes"><Yes />Yes</label>

          <input type="radio" name="antiDepressants" id="antiDepressantsNo" value="no" onChange={props.logMedicationAnswer} checked={props.medicationAnswer === 'no'} />
          <label className="answer-button answer-button__glasses" htmlFor="antiDepressantsNo"><No />No</label>
        </div>
      </div>

      {props.gender !== 'male' ?
        <>
          <a href="#natal" className={`question-divider ${props.medicationAnswer ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>

          <div id="natal" className={`kids-quiz__question ${props.medicationAnswer ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
            <p className="question__title">Are you pre/post natal, currently pregnant or breast feeding?</p>
            <div className="answers-row--flex health-answers">
              {props.renderNatalAnswers}
            </div>
          </div>

          <div className={`next-page ${props.natalAnswerIndex.length > 0 ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('4')}>Continue</div>
        </>
        :
        <div className={`next-page ${props.medicationAnswer ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('4')}>Continue</div>
      }

    </div>
  );
}

export default PageFour;